import React, {ChangeEvent, useState} from 'react';
import './App.css';

const App = () => {
  
  // input
  const[vystupniTeplota, setVystupniTeplota] = useState<number>(55);
  const[vstupniTeplota, setVstupniTeplota] = useState<number>(10);
  const[objemVody, setObjemVody] = useState<number>(200);
  const[prikon, setPrikon] = useState<number>(15);
  const[ucinnost, setUcinnost] = useState<number>(0.98);
  const[errorStatement, setErrorStatement] = useState<string>("");

  // handleChange pro input
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {

    errorMessage(event.target.name, event.target.value)
    
    switch (event.target.name) {

      case 'vystupniTeplota':
        const valueVystupniTeplota = event.target.value;
        setVystupniTeplota(Number(valueVystupniTeplota));      
        break;

      case 'vstupniTeplota':
        const valueVstupniTeplota = event.target.value;
        setVstupniTeplota(Number(valueVstupniTeplota));
        break;

      case 'objemVody':
        const valueObjemVody = event.target.value;
        setObjemVody(Number(valueObjemVody));
        break;

      case 'prikon':
        const valuePrikon = event.target.value;
        setPrikon(Number(valuePrikon));
        break;

      default: alert("ERROR: Někde nastala chyba!");
        break;
    };
  };

  // selectChange pro výběr paliva (účinnosti)
  const selectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const valueUcinnost = event.target.value;
    setUcinnost(Number(valueUcinnost));
  }

  //výpočty
  let V = objemVody /1000 // přepočet z litrů [dm^3] na [m^3]
  let t = ((vstupniTeplota + vystupniTeplota)/2); // celková teplota [°C]
  let hmotnostVody = V * (1000 - (((t - 4) * 0.0036 + 0.097) * (t - 4))); // hmotnost vody [kg]
  const c = 1.163; // konstanta
  
  // výpočet času
  let doba = c * hmotnostVody * (vystupniTeplota - vstupniTeplota) / (ucinnost * 1000 * prikon);
  var hodiny = Math.floor(doba);
  var zbytek = (doba - hodiny) * 60;
  var minuty = Math.floor(zbytek);
  var sekundy = Math.round((zbytek - minuty) * 60);
  if (sekundy===60) {sekundy = 0; minuty += 1}
  if (minuty===60) {minuty = 0; hodiny += 1}
  hodiny = Math.round(hodiny);
  minuty = Math.round(minuty);

  // Sada upozornění při nesprávném použití aplikace
  const errorMessage = (name:string, value:string) => {

    switch (name) {

      // Pro automatickou kontrolu je nutné nahrazení právě upravované hodnoty za (event.target.value)
      // při nastavování výstupní teploty
      case 'vystupniTeplota':
        if (Number(value) < 5 || Number(value) > 100 || vstupniTeplota < 5 || vstupniTeplota > 100 )
          {setErrorStatement("Teplota musí být v rozsahu od 5 °C do 100 °C!");}
          else if (Number(value) < vstupniTeplota)
          {setErrorStatement("Výstupní teplota je nižší než vstupní!");}
          else if (Number(value) === vstupniTeplota)
          {setErrorStatement("Vstupní a výstupní teplota je totožná!");}
          else if (objemVody <= 0) 
          {setErrorStatement("Objem vody musí být vyšší než 0!");}
          else if (prikon <= 0)
          {setErrorStatement("Příkon musí být vyšší než 0!");}
          else
          {setErrorStatement("");};  
        break;

      // při nastavování vstupní teploty
      case 'vstupniTeplota':
        if (vystupniTeplota < 5 || vystupniTeplota > 100 || Number(value) < 5 || Number(value) > 100 )
          {setErrorStatement("Teplota musí být v rozsahu od 5 °C do 100 °C!");}
          else if (vystupniTeplota < Number(value))
          {setErrorStatement("Výstupní teplota je nižší než vstupní!");}
          else if (vystupniTeplota === Number(value))
          {setErrorStatement("Vstupní a výstupní teplota je totožná!");}   
          else if (objemVody <= 0) 
          {setErrorStatement("Objem vody musí být vyšší než 0!");}
          else if (prikon <= 0)
          {setErrorStatement("Příkon musí být vyšší než 0!");}
          else
          {setErrorStatement("");};  
        break;

      // při nastavování objemu vody
      case 'objemVody':
        if (vystupniTeplota < 5 || vystupniTeplota > 100 || vstupniTeplota > 100 || vstupniTeplota > 100 )
          {setErrorStatement("Teplota musí být v rozsahu od 5 °C do 100 °C!");}
          else if (vystupniTeplota < vstupniTeplota)
          {setErrorStatement("Výstupní teplota je nižší než vstupní!");}
          else if (vystupniTeplota === vstupniTeplota)
          {setErrorStatement("Vstupní a výstupní teplota je totožná!");}   
          else if (Number(value) <= 0) 
          {setErrorStatement("Objem vody musí být vyšší než 0!");}
          else if (prikon <= 0)
          {setErrorStatement("Příkon musí být vyšší než 0!");}
          else
          {setErrorStatement("");};  
        break;

      // při nastavování příkonu
      case 'prikon':
        if (vystupniTeplota < 5 || vystupniTeplota > 100 || vstupniTeplota > 100 || vstupniTeplota > 100 )
          {setErrorStatement("Teplota musí být v rozsahu od 5 °C do 100 °C!");}
          else if (vystupniTeplota < vstupniTeplota)
          {setErrorStatement("Výstupní teplota je nižší než vstupní!");}
          else if (vystupniTeplota === vstupniTeplota)
          {setErrorStatement("Vstupní a výstupní teplota je totožná!");}   
          else if (objemVody <= 0) 
          {setErrorStatement("Objem vody musí být vyšší než 0!");}
          else if (Number(value) <= 0)
          {setErrorStatement("Příkon musí být vyšší než 0!");}
          else
          {setErrorStatement("");};  
        break;

      // defaultní hodnota
      default: alert("ERROR: Někde nastala chyba!");
        break;
    }
  };

  // render
  return (
    <div className="App">

      <h1>Výpočet doby ohřevu vody v bojleru</h1>

      <table>
        <tr>
          <th title='Výstupní teplota'><label htmlFor="vystupniTeplota">t<sub>2</sub>:</label></th>
          <td><input type="number" step="any" id="vystupniTeplota" name="vystupniTeplota" value={vystupniTeplota} onChange={handleChange} />&nbsp;&nbsp;&nbsp;<text>°C</text></td>
        </tr>
        <tr>
          <th title='Vstupní teplota'><label htmlFor="vstupniTeplota">t<sub>1</sub>:</label></th>
          <td><input type="number" step="any" id="vstupniTeplota" name="vstupniTeplota" value={vstupniTeplota} onChange={handleChange} />&nbsp;&nbsp;&nbsp;<text>°C</text></td>
        </tr>
        <tr>
          <th title='Objem vody'><label htmlFor="objemVody">V:</label></th>
          <td><input type="number" step="any" id="objemVody" name="objemVody" value={objemVody} onChange={handleChange} />&nbsp;&nbsp;&nbsp;<text>l</text></td>
        </tr>
        <tr>
          <th title='Příkon'><label htmlFor="prikon">P:</label></th>
          <td><input type="number" step="any" id="prikon" name="prikon" value={prikon}  onChange={handleChange} />&nbsp;&nbsp;&nbsp;<text>kW</text></td>
        </tr>
        <tr>
          <th title='Typ paliva ovlivňující účinnost'>Palivo:</th>
          <td>
            <select onChange={selectChange} name="palivo">
              <option value={0.98}>Elektřina</option>
              <option value={0.78}>Hnědé uhlí</option>
              <option value={0.78}>Černé uhlí</option>
              <option value={0.85}>Dřevo</option>
              <option value={0.85}>Dřevěné brikety</option>
              <option value={0.90}>Dřevěné pelety</option>
              <option value={0.85}>Dřevěná štěpka</option>
            </select>
            &nbsp;&nbsp;&nbsp;
            <text><label title="Účinnost">η: {ucinnost.toFixed(2)}</label></text>
          </td>
        </tr>
        <tr>
          <th title="Doba ohřevu">t = </th>
          <td>{hodiny}&nbsp;hodin&nbsp;{minuty}&nbsp;minut</td>
        </tr>
      </table>
      
      <div className="Error">
        {errorStatement}
      </div>
    </div>
  );
};

export default App;